document.addEventListener('DOMContentLoaded',function(){
  if(!document.body.classList.contains('template-index'))return;

  var selectors=['.visual-category','.trust-item','.hp-products .section-head','.hp-product-card','.pet-home-copy','.pet-home-media','.lifestyle-section','.newsletter','.review-card'];
  var items=[];

  selectors.forEach(function(selector){
    document.querySelectorAll(selector).forEach(function(el){
      if(items.indexOf(el)===-1)items.push(el);
    });
  });

  ['.visual-category','.trust-item','.hp-product-card','.review-card'].forEach(function(selector){
    document.querySelectorAll(selector).forEach(function(el,index){
      el.style.setProperty('--spark-delay',((index%4)*80)+'ms');
    });
  });

  items.forEach(function(el){el.classList.add('spark-motion')});

  if(!('IntersectionObserver' in window)){
    items.forEach(function(el){el.classList.add('spark-in-view')});
    return;
  }

  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('spark-in-view');
        observer.unobserve(entry.target);
      }
    });
  },{threshold:.12,rootMargin:'0px 0px -5% 0px'});

  items.forEach(function(el){observer.observe(el)});
});
